import { render, staticRenderFns } from "./AdmissionPA.vue?vue&type=template&id=6331a877"
import script from "./AdmissionPA.vue?vue&type=script&lang=js"
export * from "./AdmissionPA.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports